import React from "react";
import { Box } from "@mui/material";

const colorMap = {
  green: {
    color: "#389e0d",
    backgroundColor: "#f6ffed",
    borderColor: "#b7eb8f",
  },
  red: {
    color: "#cf1322",
    backgroundColor: "#fff1f0",
    borderColor: "#ffa39e",
  },
  orange: {
    // Añadiendo una entrada para el naranja
    color: "#d48806",
    backgroundColor: "#fffbe6",
    borderColor: "#ffe58f",
  },
  default: {
    color: "#000000",
    backgroundColor: "#ffffff",
    borderColor: "#cccccc",
  },
};

const Tag = ({ text, colorChoice, sx }) => {
  const { color, backgroundColor, borderColor } =
    colorMap[colorChoice] || colorMap.default;
  const tagStyle = {
    display: "inline-block",
    padding: "4px 8px",
    borderRadius: "4px",
    fontSize: { xs: "14px", md: "16px" },
    color,
    backgroundColor,
    borderColor,
    borderStyle: "solid",
    borderWidth: "1px",
  };

  return <Box sx={{ ...sx, ...tagStyle }}>{text}</Box>;
};

export default Tag;
